import types from '../constants'
import { findIndexByKeyValue } from './util'

const initialState = {
  playlists: {
    meta: {
      background: '',
      description: '',
      title: '',
      status: 'loading',
    },
    data: [],
  },
  children: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  banners: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  attributes: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
}

export default function playlist(state = initialState, action) {
  switch (action.type) {
    case types.GET_PLAYLIST_LOADING:
      state.children.meta.status = 'loading'
      state.children.data = []
      return { ...state, playlists: { ...action.payload } }
    case types.GET_PLAYLIST_SUCCESS:
      return { ...state, playlists: { ...action.payload } }
    case types.GET_PLAYLIST_ERROR:
      return { ...state, playlists: { ...action.payload } }
    case types.GET_PLAYLIST_RESET:
      return { ...initialState }
    case types.GET_PLAYLIST_BANNER_LOADING:
      return {
        ...state,
        banners: { ...action.payload },
      }
    case types.GET_PLAYLIST_BANNER_SUCCESS:
      return {
        ...state,
        banners: { ...action.payload },
      }
    case types.GET_PLAYLIST_BANNER_ERROR:
      return {
        ...state,
        banners: { ...action.payload },
      }
    case types.GET_PLAYLIST_CHILD:
      // console.log('home state', state)
      let result = [...state.children.data],
        status
      const index = findIndexByKeyValue(result, 'id', action.payload.meta.id)
      // filteredStatus = state.children.data.filter(({ meta }) => meta.status === 'error').length > 0

      // if (filteredStatus) {
      //   status = 'error'
      // } else
      if (state.children.data.length < state.playlists.data.length - 1) {
        status = 'loading'
      } else {
        status = 'success'
      }

      if (index === -1) {
        result.push({ ...action.payload })
        result = result.sort((a, b) => a.meta.sortOrder - b.meta.sortOrder)
      }

      return {
        ...state,
        children: {
          ...state.children,
          meta: { status, error: status === 'error' ? 'API Video failed' : '' },
          data: result,
        },
      }
    case types.GET_PLAYLIST_ATTRIBUTES_LOADING:
      return { ...state, attributes: { ...action.payload } }
    case types.GET_PLAYLIST_ATTRIBUTES_SUCCESS:
      return { ...state, attributes: { ...action.payload } }
    case types.GET_PLAYLIST_ATTRIBUTES_ERROR:
      return { ...state, attributes: { ...action.payload } }
    case types.PLAYLIST_VIDEO_REMINDERS:
      let currentChild = {...state.children}
      currentChild.data.map((child)=> {
        if (child.meta.id === action.payload.playlistId) {
          child.reminders = action.payload.reminders
        }
      })
      return {
        ...state,
        children: {...currentChild}
      }
    default:
      return {
        ...initialState,
        ...state,
      }
  }
}
